function cashSnapshotOpenChoice(snapshot) {
  if (!snapshot || Array.isArray(snapshot)) return 'previous';
  const items = snapshot.cash_items && snapshot.cash_items.items;
  if (!Array.isArray(items) || items.length === 0) return 'previous';
  return 'today';
}

module.exports = {
  cashSnapshotOpenChoice,
};
